// routes are grouped by the session they belong to
import windrowRegistrationRoutes from "./windrowRegistrationRoutes.js";
import parkingPermitRoutes from "./parkingPermitRoutes";
import monthlyParkingPermitRoutes from "./monthlyParkingPermitRoutes";
import taxAdjustmentRoutes from "./taxAdjustmentRoutes";
import estorePOCRoutes from "./estorePOCRoutes.js";
import { createRouter, createWebHistory } from "vue-router";
import agendaAndMeetingRoutes from "./agendaAndMeetingRoutes.js";
import stormwaterRoutes from "./stormwaterRoutes.js";
import marinaRoutes from "./marinaRoutes.js";
import banquetInquiryRoutes from "./banquetInquiryRoutes.js";
import roadClosureAlertRoutes from "./roadClosureAlertRoutes.js";
import treePermitRoutes from "./treePermitRoutes.js";

import launchPermitRoutes from '@/routes/launchPermitRoutes';
import onlineInquiryRoutes from '@/routes/onlineInquiryRoutes';
// ROUTE IMPORTS (DO NOT REMOVE)

const routes = [
  ...windrowRegistrationRoutes,
  ...parkingPermitRoutes,
  ...monthlyParkingPermitRoutes,
  ...taxAdjustmentRoutes,
  ...estorePOCRoutes,
  ...agendaAndMeetingRoutes,
  ...stormwaterRoutes,
  ...marinaRoutes,
  ...banquetInquiryRoutes,
  ...roadClosureAlertRoutes,
  ...treePermitRoutes,
  ...launchPermitRoutes,
  ...onlineInquiryRoutes,
  {
    path: "/",
    component: () => import("../layout/PageLayoutWithoutContainer.vue"),
    redirect: "/windrow-registration"
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: () => import("@/views/NotFoundPage.vue")
  },
  // ROUTE REGISTRATION (DO NOT REMOVE)
];

const router = createRouter({
  history: createWebHistory(`${process.env.BASE_URL}/#`),
  routes: [...routes],
  strict: true
});
// Keep Scroll position on page load
const lastScrollPos = { x: 0, y: 0 };
router.beforeEach((to, from, next) => {
  window.previousUrl = from.path;
  lastScrollPos.y = window.scrollY;
  next();
});

export default router;
